var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiLabelLightorange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.686,
    height: 44.414,
    viewBox: "0 0 186.686 44.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UI_label_lightorange",
    d: "M-31.044,3.519-26.564,14.9l-4.38,26.55,185.219-5.833-4.942-15.95L154.952.273Z",
    transform: "matrix(1, 0.017, -0.017, 1, 31.763, 0.269)",
    fill: "#f1e1c5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLabelLightorange);
export default __webpack_public_path__ + "static/media/UI_label_lightorange.02bcbc61c05a1317727419274bd267e1.svg";
export { ForwardRef as ReactComponent };